function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as t } from "react/jsx-runtime";
import * as a from "react";
import { useFieldProps as x } from "./form-context.js";
import { TextFieldBaseAutosuggest as O } from "./text-field-base.js";
import { isInputTypeSupported as b } from "./utils/dom.js";
import { isServerSide as v } from "./utils/environment.js";
import E from "./generated/mistica-icons/icon-calendar-regular.js";
import { getLocalDateString as r } from "./utils/time.js";
import { useTheme as j } from "./hooks.js";
import { isFirefox as z } from "./utils/platform.js";
const A = /*#__PURE__*/ a.lazy(()=>import(/* webpackChunkName: "date-time-picker" */ "./date-time-picker.js")), B = (_param)=>{
    var { disabled: l , error: g , helperText: D , name: y , optional: m , validate: s , onChange: F , onChangeValue: n , onBlur: R , value: S , defaultValue: h , min: o , max: i  } = _param, d = _object_without_properties(_param, [
        "disabled",
        "error",
        "helperText",
        "name",
        "optional",
        "validate",
        "onChange",
        "onChangeValue",
        "onBlur",
        "value",
        "defaultValue",
        "min",
        "max"
    ]);
    const k = (e)=>e, I = a.useMemo(()=>z() ? !1 : b("date"), []), { texts: T  } = j(), f = (e)=>!(o && e && e < r(o) || i && e && e > r(i)), u = x({
        name: y,
        value: S,
        defaultValue: h,
        processValue: k,
        helperText: D,
        optional: m,
        error: g,
        disabled: l,
        onBlur: R,
        validate: (e, c)=>f(e) ? s == null ? void 0 : s(e, c) : T.formDateOutOfRangeError,
        onChange: F,
        onChangeValue: (e, c)=>{
            f(e) && (n == null || n(e, c));
        }
    }), p = /* @__PURE__ */ t(O, _object_spread_props(_object_spread({}, d, u), {
        min: o ? r(o) : void 0,
        max: i ? r(i) : void 0,
        type: "date",
        endIconOverlay: /* @__PURE__ */ t("div", {
            style: {
                position: "absolute",
                top: 16,
                right: 16,
                pointerEvents: "none"
            },
            children: /* @__PURE__ */ t(E, {})
        })
    }));
    return I || v() ? p : /* @__PURE__ */ t(a.Suspense, {
        fallback: p,
        children: /* @__PURE__ */ t(A, _object_spread_props(_object_spread({}, d, u), {
            optional: m,
            isValidDate: (e)=>f(r(e.toDate()))
        }))
    });
}, K = B;
export { K as default };
